import React, { useState, useEffect,useMemo } from 'react';
import Swal from 'sweetalert2'; // Import SweetAlert2
import { API_BASE_URL } from '../../api';
import axios from 'axios';
import Select from 'react-select';


const Edit_Website = ({ website, onClientUpdated }) => {
    const [formData, setFormData] = useState({
        client_id: website?.client_id || '',
        websiteurl: website?.websiteurl || '',
        domain_renewal_date: website?.domain_renewal_date || '',
        invoice_renewal_date: website?.invoice_renewal_date || '',
        remarks: website?.remarks || '',
        mail: website?.mail || '',
        server: website?.server || '',
        status: website?.status || 'live',
        created_by: localStorage.getItem('userId'),
        amount: website?.amount || '',
        renewal_amount: website?.renewal_amount || '',
    });

    const [clients, setClients] = useState([]);
    const [loadingClients, setLoadingClients] = useState(true); // Add loading state for clients

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/client`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                        'Content-Type': 'application/json',
                    },
                });


                if (response.status === 200) {
                    setClients(response.data);
                } else {
                    console.error('Failed to fetch clients');
                }
            } catch (error) {
                console.error('Error fetching clients:', error);
            } finally {
                setLoadingClients(false);
            }
        };

        fetchClients();
    }, []);

    // Set form data when website prop changes
    useEffect(() => {
        if (website) {
            setFormData({
                client_id: website.client_id || '',
                websiteurl: website.websiteurl || '',
                domain_renewal_date: website.domain_renewal_date || '',
                invoice_renewal_date: website.invoice_renewal_date || '',
                remarks: website.remarks || '',
                mail: website.mail || '',
                server: website.server || '',
                status: website.status || 'live',
                created_by: localStorage.getItem('userId'),
                amount: website.amount || '',
                renewal_amount: website.renewal_amount || '',
            });
        }
    }, [website]);

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission to update website data
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(
                `${API_BASE_URL}/api/website/${website.id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                }
            );

            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Website updated successfully!',
                    confirmButtonText: 'OK',
                });
                onClientUpdated(); // Notify parent component to refresh the data
                window.location.reload();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Failed to update website. Please try again.',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            console.error('Error updating website:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred. Please try again.',
                confirmButtonText: 'OK',
            });
        }
    };
      // 
      const clientOptions = useMemo(
        () =>
            clients.map((client) => ({
                value: client.id,
                label: client.full_name,
            })),
        [clients]
    );

    // Handler for react-select components
    const handleSelectChange = (selectedOption, actionMeta) => {
        setFormData((prevData) => ({
            ...prevData,
            [actionMeta.name]: selectedOption ? selectedOption.value : '',
        }));
    };

    // Handler for standard input fields
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    // Create selected option object for the client select
    const selectedClientOption = clientOptions.find(
        (option) => option.value === formData.client_id
    ) || null;


    return (
        <div className="modal fade" id="edit_website" tabIndex="-1" aria-labelledby="edit_website_label" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title" id="edit_website_label">Edit Website</h4>
                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body text-start">
                            <div className="row">
                                {/* Client Name Dropdown */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Client Name</label>
                                    {loadingClients ? (
                                        <p>Loading clients...</p>
                                    ) : (
                                        <Select
                                            options={clientOptions}
                                            name="client_id"
                                            value={selectedClientOption}
                                            onChange={handleSelectChange}
                                            placeholder="Select Client"
                                        />
                                    )}
                                </div>

                                {/* Website URL Input */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Website Link</label>
                                    <input
                                        type="text"
                                        name="websiteurl"
                                        value={formData.websiteurl}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                    />
                                </div>

                                {/* Domain Renewal Date */}
                                <div className="col-6 mb-3">
                                    <label className="form-label">Domain Renewal Date</label>
                                    <input
                                        type="date"
                                        name="domain_renewal_date"
                                        value={formData.domain_renewal_date}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                    />
                                </div>

                                {/* Invoice Renewal Date */}
                                <div className="col-6 mb-3">
                                    <label className="form-label">Invoice Renewal Date</label>
                                    <input
                                        type="date"
                                        name="invoice_renewal_date"
                                        value={formData.invoice_renewal_date}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                    />
                                </div>

                                {/* Remarks */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Remarks</label>
                                    <textarea
                                        name="remarks"
                                        value={formData.remarks}
                                        onChange={handleChange}
                                        className="form-control"
                                        rows="3"
                                    ></textarea>
                                </div>

                                {/* Email */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Email ID</label>
                                    <input
                                        type="text"
                                        name="mail"
                                        value={formData.mail}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                 
                                </div>

                                {/* Server */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Server</label>
                                    <input
                                        type="text"
                                        name="server"
                                        value={formData.server}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                </div>
                                
                                {/* Amount */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Amount</label>
                                    <input
                                        type="text"
                                        name="amount"
                                        value={formData.amount}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                </div>
                                
                                {/* Renewal Amount */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Renewal Amount</label>
                                    <input
                                        type="text"
                                        name="renewal_amount"
                                        value={formData.renewal_amount}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                </div>

                                {/* Status */}
                                <div className="col-12 mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                        className="form-control"
                                    >
                                        <option value="live">Live</option>
                                        <option value="hold">Hold</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light me-2"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Update Website
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Edit_Website;
